import { INNER_ROUTES } from '@app/dashboard/constants/inner-routes';
import {
  Check,
  Clock,
  Xmark
} from '@unified-checkout/design-system/icons/index';
import type { TFunction } from 'i18next';

export const BILLS_OTP_MAX_WIDTH = '25rem';
export const BILLS = 'BILLS';
export const YOUR_BALANCE_ID = 'BALANCE_TOP_UP';
export const TABLE_ID = 'bills_history_table';
export const BILLS_HISTORY_TAB_ID = 'History';
export const BILLS_DISTRIBUTOR_HISTORY_TAB_ID = 'Distributor history';
export const SAVED_MERCHANTS_TAB_ID = 'Saved merchants';
export const SAVED_BILLS_TAB_ID = 'Saved bills';
export const ALL_SERVICES_ID = 'all-services';
export const AMOUNT = 'amount';
export const MOBILE_WALLET = 'MOBILE_WALLET';
export const PHONE_NUMBER = 'phone_number';
export const FUND = 'fund';
export const IS_FUND_SECTION = 'is_fund_section';
export const CONNECT_ACTION = 'connect';
export const DISCONNECT_ACTION = 'disconnect';
export const DISCONNECT_CONNECT_MODAL = 'Connect Disconnect Modal'
export const CHECKOUT = 'checkout';
export const INQUIRY = 'inquiry';
export const PARTAIL_AMOUNT_ENTRY = "partial_amount_entry"
export const ADS_TOP_UP_MODAL = 'Ads Top Up Modal'
export const CLOSE = 'close';
export const EXIT = 'exit';
export const CANCEL = 'cancel';
export const GOOGLE = 'google';
export const VAT_AMOUNT = 14.77;
export const SERVICES_FEE = 5.50;
export const FEE_RATE = (VAT_AMOUNT + SERVICES_FEE) / 100;

export const MODAL_STEP_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  PENDING: 'pending',
  OTP: 'otp',
  CONFIRM: 'confirm',
  SMS_STEPS: 'sms_steps'
} as const;


export const BREADCRUMBS_LINKS = (t: TFunction, navigate: any) => [
  {
    text: t('innerLayout.billsPage.breadcrumbs.bills'),
    onClickHandler: () => navigate(INNER_ROUTES.BILLS),
    active: true,
  },
  {
    text: t('innerLayout.billsPage.payAds.title'),
    active: false,
  },
];

export const BILLS_STATUS = () => [
  {
    id: MODAL_STEP_STATUS.SUCCESS,
    status: 'success',
    icon: Check,
  },

  {
    id: MODAL_STEP_STATUS.FAILED,
    status: 'error',
    icon: Xmark,
  },

  {
    id: MODAL_STEP_STATUS.PENDING,
    status: 'default',
    icon: Clock,
  },
] as const;

export const DELETE_STATUS = (t: TFunction) => [
  {
    id: MODAL_STEP_STATUS.SUCCESS,
    status: 'success',
    icon: Check,
    hintText: t('innerLayout.billsPage.deleteModal.successHint'),
  },

  {
    id: MODAL_STEP_STATUS.FAILED,
    status: 'error',
    icon: Xmark,
    hintText: t('innerLayout.billsPage.deleteModal.errorHint'),
  },
] as const;

export const OTP_STATUS = (t: TFunction) => [
  {
    id: MODAL_STEP_STATUS.SUCCESS,
    status: 'success',
    icon: Check,
    hintText: t('innerLayout.billsPage.transferModal.otpSuccessHint'),
  },

  {
    id: MODAL_STEP_STATUS.FAILED,
    status: 'error',
    icon: Xmark,
    hintText: t('innerLayout.billsPage.transferModal.otpErrorHint'),
  },
] as const;

export const UPDATE_BILLS_STATUS = (t: TFunction) => [
  {
    id: MODAL_STEP_STATUS.SUCCESS,
    status: 'success',
    icon: Check,
    hintText: t('innerLayout.billsPage.savedBills.updateModal.successHint'),
  },

  {
    id: MODAL_STEP_STATUS.FAILED,
    status: 'error',
    icon: Xmark,
    hintText: t('innerLayout.billsPage.savedBills.updateModal.errorHint'),
  },
] as const;

export const DELETE_BILLS_STATUS = (t: TFunction) => [
  {
    id: MODAL_STEP_STATUS.SUCCESS,
    status: 'success',
    icon: Check,
    hintText: t('innerLayout.billsPage.savedBills.deleteModal.successHint'),
  },

  {
    id: MODAL_STEP_STATUS.FAILED,
    status: 'error',
    icon: Xmark,
    hintText: t('innerLayout.billsPage.savedBills.deleteModal.errorHint'),
  },
] as const;
